import { makeAutoObservable, runInAction } from 'mobx';
import { FeatureFlags, fetchFeatureFlags, fetchPublicFlags } from 'services/featureFlagService';

export class FeatureFlagStore {
  flags: FeatureFlags = {};
  isLoaded: boolean = false;
  isLoading: boolean = false;
  publicFlags: FeatureFlags = {};
  isPublicLoaded: boolean = false;
  isPublicLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async loadFlags(): Promise<void> {
    if (this.isLoading) return;
    this.isLoading = true;

    try {
      const flags = await fetchFeatureFlags();
      runInAction(() => {
        this.flags = flags;
        this.isLoaded = true;
      });
    } catch (error) {
      console.error('Failed to load feature flags:', error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  isEnabled(key: string): boolean {
    return this.flags[key] ?? false;
  }

  async loadPublicFlags(): Promise<void> {
    if (this.isPublicLoading) return;
    this.isPublicLoading = true;
    try {
      const flags = await fetchPublicFlags();
      runInAction(() => {
        this.publicFlags = flags;
        this.isPublicLoaded = true;
      });
    } catch (error) {
      console.error('Failed to load public feature flags:', error);
      runInAction(() => {
        this.isPublicLoaded = true; // treat as loaded (all flags off) so routes can redirect
      });
    } finally {
      runInAction(() => {
        this.isPublicLoading = false;
      });
    }
  }

  isPublicEnabled(key: string): boolean {
    return this.publicFlags[key] ?? false;
  }

  reset(): void {
    this.flags = {};
    this.isLoaded = false;
    this.isLoading = false;
    this.publicFlags = {};
    this.isPublicLoaded = false;
    this.isPublicLoading = false;
  }
}
